import React from "react";
import { Linkedin, Facebook } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <footer className="bg-primary text-white pt-12 md:pt-16 pb-6 md:pb-8 min-h-[400px] md:min-h-[450px]">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <img
                src="/alpha_logo_white.png"
                className="w-20 h-20 text-secondary"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Your trusted partner in financial assurance, compliance, and
              strategic growth.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="text-gray-300 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://wa.me/+96103769664"
                className="text-gray-300 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} size="lg" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Services</h4>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li>
                <a href="#" className="hover:text-secondary transition-colors">
                  Audit
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-secondary transition-colors">
                  Accounting and Bookkeeping
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-secondary transition-colors">
                  Tax and Social Security
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-secondary transition-colors">
                  Financial Advisory & Consulting
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Company</h4>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li>
                <Link
                  to="why-alpha"
                  smooth={true}
                  className="cursor-pointer hover:text-secondary transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="services"
                  smooth={true}
                  className="cursor-pointer hover:text-secondary transition-colors"
                >
                  Our Services{" "}
                </Link>
              </li>
              {/* <li>
                <Link
                  to="testimonials"
                  smooth={true}
                  className="cursor-pointer hover:text-secondary transition-colors"
                >
                  Testimonials
                </Link>
              </li> */}
              {/* <li>
                <a href="#" className="hover:text-secondary transition-colors">
                  Careers
                </a>
              </li> */}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Contact</h4>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li>Boulevard Center, 3rd Floor

Michel Zakhour, Beirut, Lebanon</li>
              <li className="pt-2">contact@alphaauditing.com</li>
              {/* <li>+961 03 769 664</li> */}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-300 text-sm">
          <p>
            &copy; {new Date().getFullYear()} Alpha Audit Firm. All rights
            reserved.
          </p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-300 hover:text-white">
              Privacy
            </a>
            <a href="#" className="text-gray-300 hover:text-white">
              Terms
            </a>
            <a href="#" className="text-gray-300 hover:text-white">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
